import axios from 'axios';

const SERVICE_URL_CONTRACTS = '/contratos';

const SET_CONTRACTS = 'SET_CONTRACTS';
const SET_NEW_CONTRACT = 'SET_NEW_CONTRACT';
const CLEAR_NEW_CONTRACT = 'CLEAR_NEW_CONTRACT';
const SET_USER_CONTRACTS = 'SET_USER_CONTRACTS';
const USER_CONTRACT_ASSINGN_INVENTORY = 'USER_CONTRACT_ASSINGN_INVENTORY';
const ASSIGN = 'ASSIGN';
const CLEAR_USER_CONTRACT = 'CLEAR_USER_CONTRACT';
const CLEAR_CONTRACTS = 'CLEAR_CONTRACTS';
const CLEAR_USER_ALL_CONTRACTS = 'CLEAR_USER_ALL_CONTRACTS';
const ADD_PENDING_CONTRACTS = 'ADD_PENDING_CONTRACTS';
const RECEIVE_CONTRACTS_OWN = 'RECEIVE_CONTRACTS_OWN';
const SET_ALL_CONTRACTS_USER = 'SET_ALL_CONTRACTS_USER';

// Helper
function axiosConfig() {
    return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
}

const borra = { me: null };

function putoIEAssign(o, k, v) {
    borra.me = o[k];
    o[k] = v;
    delete borra.me;
}

const getDefaultState = () => ({
    contracts: [],
    userContracts: [],
    allcontractsUser: [],
    newContract: {},
    contracts_own: []
});
const state = getDefaultState();

const getters = {
    contracts: state => state.contracts,
    newContract: state => state.newContract,
    userContracts: state => state.userContracts,
    allcontractsUser: state => state.allcontractsUser,
    contracts_own: state => state.contracts_own,
};

const actions = {
    getOwnContractsWithInventory({ commit }) {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        };
        return axios
            .get(`${SERVICE_URL_CONTRACTS}ownContractWhitInventory/${JSON.parse(localStorage.getItem('role')).faena_id}`, config)
            .then((response) => {
                commit(RECEIVE_CONTRACTS_OWN, response.data);
            })
            .catch((error) => {
                if (error) {
                    console.log(error);
                }
            });
    },

    async clearUserContract({ commit }) {
        commit(CLEAR_USER_CONTRACT);
    },

    userContractAssign({ commit }, { obj, val }) {
        const validar = {
            area_id: true,
            faena_id: true,
            fecha_fin: true,
            fecha_inicio: true,
            inventario: true,
            nombre: true,
            tipo_contrato: true,
        };
        const val2 = JSON.parse(JSON.stringify(val));

        Object.keys(val).forEach((i) => {
            if (!validar[i]) delete val2[i];
        });

        commit(ASSIGN, { obj, val: val2 });
    },

    contractAssign({ commit }, { obj, val }) {
        commit(ASSIGN, { obj, val });
    },

    async userContractAssignInventory({ state, commit }, { inventoryId, obj }) {
        const contract = state.userContracts
            .find(c => c.inventario && c.inventario._id === inventoryId);

        if (contract) {
            commit(USER_CONTRACT_ASSINGN_INVENTORY, { contract, obj });
        } // if
    },

    // hay que vaciar las variables que cambian segun el rol
    // en las paginas se consulta si no tiene datos entonces intenta buscar
    // por eso la importancia de dejarlas vacias
    // en caso de no hacerlo tendria almacenadas las del anterior rol
    async resetContract({ commit }) {
        commit(SET_CONTRACTS, []);
    },

    async resetUserAllContracts({ commit }) {
        commit(CLEAR_USER_ALL_CONTRACTS);
    },

    async resetUserContractByRole({ commit }) {
        commit(SET_USER_CONTRACTS, []);
    },

    async getContractsFaena({ commit }) {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        };
        return axios
            .get(
                `${SERVICE_URL_CONTRACTS}/by-faena-min/${JSON.parse(localStorage.getItem('role')).faena_id}`,
                config,
            )
            .then((response) => {
                commit(SET_CONTRACTS, response.data);
            })
            .catch((error) => {
                if (error) {
                    console.log(error);
                }
            });
    },

    saveContract({ commit }) {
        return new Promise((resolve) => {
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            };
            // save faena_id
            state.newContract.faena_id = JSON.parse(localStorage.getItem('role')).faena_id;

            axios.post(`${SERVICE_URL_CONTRACTS}/crear`, state.newContract, config).then((response) => {
                if (!response.data.success) {
                    resolve({
                        message: response.data.message,
                        success: false,
                    });
                } else {
                    commit(CLEAR_NEW_CONTRACT);
                    commit(CLEAR_USER_CONTRACT);
                    commit(CLEAR_CONTRACTS);
                    resolve({
                        success: true,
                    });
                }
            });
        });
    },

    editContract({ commit }, contract) {
        console.log(contract);
        return new Promise((resolve) => {
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            };
            axios
                .post(`${SERVICE_URL_CONTRACTS}/edit/${contract.id}`, contract.body, config)
                .then((response) => {
                    if (!response.data.success) {
                        resolve({
                            message: response.data.message,
                            success: false,
                        });
                    } else {
                        resolve({
                            success: true,
                        });
                    }
                });
        });
    },

    editContractSpecificField({ commit }, contract) {
        return new Promise((resolve) => {
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            };
            axios
                .post(`${SERVICE_URL_CONTRACTS}/editContract/${contract.id}`, contract.body, config)
                .then((response) => {
                    if (!response.data.success) {
                        resolve({
                            message: response.data.message,
                            success: false,
                        });
                    } else {
                        resolve({
                            success: true,
                        });
                    }
                });
        });
    },

    setNewContract({ commit }, newContract) {
        commit(SET_NEW_CONTRACT, newContract);
    },

    resetNewContract({ commit }, newContract) {
        commit(CLEAR_NEW_CONTRACT);
    },

    // Multirroles
    async getUserContractByRole({ commit }, { user, role }) {
        try {
            // Definir url consulta
            let url = `${SERVICE_URL_CONTRACTS}/byUFAER?userId=${user._id}&faenaId=${role.faena_id}`;
            url = role.admin ? `${url}&role=admin` : (role.area_id === 'GeneralAreasRoles' ? `${url}&role=allAreas` : `${url}&role=${role.role}`);
            url = url + `&actualRole=${role.role}`;
            if (role.area_id) { url = `${url}&areaId=${role.area_id}`; }
            if (role.empresa_id) { url = `${url}&empresaId=${role.empresa_id}`; }

            const response = await axios.get(url, axiosConfig());
            if (response.data && response.data.status && response.data.contratos) {
                commit(SET_USER_CONTRACTS, response.data.contratos);
            }
            return true;
        } catch (e) {
            console.log(e);
            return false;
        }
    },

    async getAllContractsFaena({ commit }, faena_id) {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        };
        return axios
            .get(
                `${SERVICE_URL_CONTRACTS}/byFaenaMinInventory/${faena_id}`,
                config,
            )
            .then((response) => {
                commit(SET_ALL_CONTRACTS_USER, response.data);
            })
            .catch((error) => {
                if (error) {
                    console.log(error);
                }
            });
    },
};

const mutations = {
    [RECEIVE_CONTRACTS_OWN](state, contracts) {
        state.contracts_own = contracts;
    },
    [SET_ALL_CONTRACTS_USER](state, contracts) {
        state.allcontractsUser = contracts;
    },
    [CLEAR_USER_CONTRACT](state) {
        state.userContracts = [];
    },
    [CLEAR_CONTRACTS](state) {
        state.contracts = [];
    },
    [ASSIGN](state, { obj, val }) {
        Object.assign(obj, val);
    },
    [USER_CONTRACT_ASSINGN_INVENTORY](state, { contract, obj }) {
        Object.assign(contract.inventario, obj);
        console.log('contract', contract);
    },
    [SET_CONTRACTS](state, contracts) {
        putoIEAssign(state, 'contracts', contracts);
    },
    [SET_USER_CONTRACTS](state, contracts) {
        putoIEAssign(state, 'userContracts', contracts);
    },
    [SET_NEW_CONTRACT](state, newContract) {
        state.newContract = newContract;
    },
    [CLEAR_NEW_CONTRACT](state) {
        state.newContract = {};
    },
    [CLEAR_USER_ALL_CONTRACTS](state) {
        state.allcontractsUser = [];
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
